import { render } from "./maintenance.vue?vue&type=template&id=841f946c&scoped=true"
const script = {}

import "./maintenance.vue?vue&type=style&index=0&id=841f946c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-841f946c"]])

export default __exports__